import { render, staticRenderFns } from "./SafeProjects.vue?vue&type=template&id=38d9e1d5&scoped=true&"
import script from "./SafeProjects.vue?vue&type=script&lang=js&"
export * from "./SafeProjects.vue?vue&type=script&lang=js&"
import style0 from "./SafeProjects.vue?vue&type=style&index=0&id=38d9e1d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d9e1d5",
  null
  
)

export default component.exports